var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info")]), _c('div', {
    staticClass: "flex justify-center items-start gap-6"
  }, [_c('div', {
    staticClass: "w-1/5"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "ID",
      "disabled": ""
    },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v;
      },
      expression: "id"
    }
  })], 1), _c('div', {
    staticClass: "w-4/5"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama Cost Mapping",
      "placeholder": "Masukan nama cost mapping",
      "error": _vm.errors['name']
    },
    model: {
      value: _vm.payloads.name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "name", $$v);
      },
      expression: "payloads.name"
    }
  })], 1)])]), _c('div', {
    staticClass: "flex justify-end gap-6 p-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.isDuplicate ? 'Duplikasi' : 'Simpan',
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.save();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }